module.exports = __webpack_public_path__ + "img/chapter-indicator-icon.be589e2f.svg";